<script>
  import { _ } from 'svelte-i18n'
  import { modals, flash_content, storefront_id_to_edit, user_storefronts, storefront_just_created, previews_storefronts_filter} from '../../stores'
  import { saveStorefrontData } from '../../services/storefronts'
  import Fieldset from '../../elements/Fieldset.svelte'
  import Label from '../../elements/Label.svelte'
  import Input from '../../elements/Input.svelte'
  import Button from '../../elements/Button.svelte'
  import FormError from '../../elements/FormError.svelte'
  import Modal from '../../elements/Modal.svelte'
  import ButtonGroup from '../../elements/ButtonGroup.svelte'

  let modal_id = 'editStorefront'
  let button_busy = false
  let form_element
  let show_save_error = false
  let storefront = null

  // Edit functionality is not used in the app anymore
  $: {
    if ($user_storefronts && $storefront_id_to_edit) {
      storefront = $user_storefronts.find(s => s.id === $storefront_id_to_edit);
    } else {
      storefront = null;
    }
  }

  async function handleSubmit(event) {

    button_busy = true;
    show_save_error = false;
    const formData = new FormData(event.target);

    try {
      const response = await saveStorefrontData({
        storefront_id: $storefront_id_to_edit || null,
        name: formData.get('name'),
        save_view_options: false
      });

      if (response.data.success) {
        modals.close();
        $flash_content = storefront ? `Changes saved to "${formData.get('name')}"` : `Storefront "${formData.get('name')}" created`;
        $storefront_just_created = true;
      } else {
        show_save_error = true;
        console.error("Error editing storefront", error);
      }
    } catch (error) {
      show_save_error = true;
      console.error("Error editing storefront", error);
    } finally {
      button_busy = false;
    }
  }
</script>

<Modal id={modal_id}>
  <span slot="header">
    {#if storefront}
      {@html $_('modals.editStorefront.title', { values: { storefront_name: storefront.name } })}
    {:else}
      {$_('modals.editStorefront.titleNew')}
    {/if}
  </span>
  <span slot="content">
    <FormError bind:visible={show_save_error}>{$_('modals.editStorefront.saveError')}</FormError>
    <form bind:this={form_element} on:submit|preventDefault={handleSubmit}>
      <Fieldset>
        <Label name="name">{$_('modals.editStorefront.nameLabel')}</Label>
        <Input 
          type="text" 
          name="name" 
          focused={true} 
          required={true}
          error={false}
          spellcheck={false}
          value={storefront?.name || ''}
          autocomplete="off"
        />
      </Fieldset>
      <p>{$_('modals.editStorefront.nameInfo')}</p>
      <small>
        {$_('modals.editStorefront.nameInfo2')}
      </small>
      <ButtonGroup mt={3}>
        <Button kind="accent" type="submit" busy={button_busy}>{storefront ? $_('buttons.save') : $_('buttons.create')}</Button>
        <Button kind="outline" on:click={() => modals.close()}>{$_('buttons.cancel')}</Button>
      </ButtonGroup>
    </form>
  </span>
</Modal>